export default "__VITE_PUBLIC_ASSET__14ab2136__"